import { Injectable, inject, isDevMode } from '@angular/core';
import { isWhitelisted } from '@navstation-portal/iframe/util/remote-communication';
import { LoggerStore } from '@navstation-portal/shared/util/logger';
import { IFRAME_URL_WHITELIST } from './whitelist.token';

@Injectable({
  providedIn: 'root',
})
export class IframeWhitelistService {
  #whitelist = inject(IFRAME_URL_WHITELIST);
  #logger = inject(LoggerStore).forFeature('Whitelist');

  get whitelist(): string[] {
    return this.#whitelist;
  }

  isWhitelisted(url: string): boolean {
    const allowed = isWhitelisted(url, this.#whitelist, isDevMode());

    if (!allowed) {
      this.#logger.error(`URL "${url}" is not whitelisted and has been blocked.`);
    } else if (!this.#whitelist.some((entry) => url.startsWith(entry)) && isDevMode()) {
      this.#logger.warn(`URL "${url}" is not in the whitelist. This would be blocked in production mode.`);
    }

    return allowed;
  }
}
